<template>
  <main class="main-content mt-0 ps">
    <section class="my-10">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 my-auto">
            <h1 class="display-1 text-bolder text-gradient text-danger">
              {{ $t('key_error_404') }}
            </h1>
            <h2>{{ $t('key_error_404_title') }}</h2>
            <p class="lead">
              {{ $t('key_error_404_description') }}
            </p>
            <soft-button color="primary" variant="gradient" class="mt-4">
              <router-link v-if="user && !user.roles.includes('CENTRAL')" :to="{ name: '/' }"
                class="px-0 font-weight-bold text-white" >
                <span>{{ $t('key_error_404_go_to_home_page') }}</span>
              </router-link>
              <!-- <router-link v-else :to="{ name: 'Dashboard Admin' }" class="px-0 font-weight-bold text-white">
                <span>{{ $t('key_error_404_go_to_home_page') }}</span>
              </router-link> -->
            </soft-button>
            >
          </div>
          <div class="col-lg-6 my-auto position-relative">
            <img
              class="w-100 position-relative"
              src="../../../assets/img/illustrations/error-404.png"
              alt="404-error"
            />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";

import { mapMutations } from "vuex";

export default {
  name: "SignupBasic",
  components: {
    SoftButton,
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
  },
};
</script>
